module.exports = __webpack_public_path__ + "img/openrndr.4848ab7d.png";